<template>
  <swiper :options="swiperOption" ref="mySwiper" >
    <swiper-slide v-for="(item,index) in data">
          <img :src="item.img" />
          <!--a @click="remove(index)" class="addImageIcon btn btn-primary btn-circle">
            <i class="fa fa-close"></i>
          </a-->
          <input type="text" style="width:100%;text-align:center;" disabled v-model="item.caption"></input>
    </swiper-slide>
  </swiper>
</template>
<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'


  export default {
    name: 'carrousel',
    data() {
      return {
        swiperOption: {
          // some swiper options/callbacks
          // 所有的参数同 swiper 官方 api 参数
          // ...
        }
      }
    },
    props: ['data'],
    components: {
        swiper,
        swiperSlide
    },
    mounted() {
    },
    methods: {
        remove:function(index){
            this.data.splice(index,1);
        },
        reflash:function(data){
          this.$set(this, "data", data);
        }
    }
  }
</script>